import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import type {
  Segment,
  UpdateSegmentRequest,
} from '@/types/models/segments/segment';
import {updateSegment} from '@/api/fetchers/segments';
import {SEGMENTS_QUERY_KEY} from '@/hooks/queries/use-segments-query';

export type UpdateSegmentVariables = {
  id: string;
  payload: UpdateSegmentRequest;
};

export default function useUpdateSegmentMutation() {
  return useMutation<Segment, Error, UpdateSegmentVariables>({
    mutationKey: [SEGMENTS_QUERY_KEY, 'update'],
    mutationFn: ({id, payload}) => updateSegment(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [SEGMENTS_QUERY_KEY]});
    },
  });
}
